"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _SettingsStickySaveFooter = _interopRequireDefault(require("settings-ui-lib/components/SettingsStickySaveFooter"));

var _UpdateFormSettings = _interopRequireDefault(require("settings-ui-modules/marketing/modules/form/stagedObjects/UpdateFormSettings"));

var _actions = require("settings-ui-sdk/FormSettings/actions");

var _selectors = require("settings-ui-sdk/FormSettings/selectors");

var _stagedSelectors = require("settings-ui-modules/marketing/modules/form/selectors/stagedSelectors");

var SaveChangesContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SaveChangesContainer, _PureComponent);

  function SaveChangesContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SaveChangesContainer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SaveChangesContainer).call(this, props));
    _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SaveChangesContainer, [{
    key: "handleCancel",
    value: function handleCancel() {
      var hasUnsavedChanges = this.props.hasUnsavedChanges;

      if (hasUnsavedChanges) {
        this.props.resetChanges();
      }
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      var _this$props = this.props,
          hasUnsavedChanges = _this$props.hasUnsavedChanges,
          unsavedChanges = _this$props.unsavedChanges;

      if (hasUnsavedChanges) {
        this.props.saveChanges(unsavedChanges);
      }
    }
  }, {
    key: "shouldRender",
    value: function shouldRender() {
      return this.props.hasUnsavedChanges;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          saveChangesRequestStatus = _this$props2.saveChangesRequestStatus,
          stagedChangesCount = _this$props2.stagedChangesCount;
      return _react.default.createElement(_SettingsStickySaveFooter.default, {
        onCancel: this.handleCancel,
        onSave: this.handleSave,
        saveRequestStatus: saveChangesRequestStatus,
        description: _react.default.createElement(_FormattedMessage.default, {
          message: 'settingsui.pendingChanges',
          options: {
            count: stagedChangesCount
          }
        }),
        shouldRender: this.shouldRender()
      });
    }
  }]);
  return SaveChangesContainer;
}(_react.PureComponent);

SaveChangesContainer.propTypes = {
  hasUnsavedChanges: _propTypes.default.bool.isRequired,
  resetChanges: _propTypes.default.func.isRequired,
  saveChanges: _propTypes.default.func.isRequired,
  saveChangesRequestStatus: _propTypes.default.string,
  unsavedChanges: _propTypes.default.object,
  stagedChangesCount: _propTypes.default.number.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasUnsavedChanges: (0, _stagedSelectors.getHasStagedChanges)(state),
    saveChangesRequestStatus: (0, _selectors.getUpdateFormSettingsRequestStatus)(state),
    unsavedChanges: _UpdateFormSettings.default.getStagedObject(state),
    stagedChangesCount: _UpdateFormSettings.default.numberOfChanges(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  resetChanges: _UpdateFormSettings.default.resetChangesToStagedObject,
  saveChanges: _actions.updateFormSettings
})(SaveChangesContainer);

exports.default = _default;
module.exports = exports.default;